import React, { useState, useEffect, useRef } from "react";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { addDays } from "date-fns";
import { registerLocale } from "react-datepicker";
import he from "date-fns/locale/he";
import "./css/datepicker-custom.css";
import { differenceInDays } from "date-fns";

registerLocale("he", he);

export default function BookingSearchBar({ onSearch }) {
  // ===== תאריכים =====
  const [dateRange, setDateRange] = useState([
    new Date(),
    addDays(new Date(), 2),
  ]);
  const startDate = dateRange[0];
  const endDate = dateRange[1];
  const [tempRange, setTempRange] = useState([startDate, endDate]);
  const nights =
    tempRange[0] && tempRange[1]
      ? differenceInDays(tempRange[1], tempRange[0])
      : 0;
  const [showDatePopup, setShowDatePopup] = useState(false);
  const [guests, setGuests] = useState(1);
  const [showGuests, setShowGuests] = useState(false);
  const handleDateChange = (update) => {
    setTempRange(update);
    if (update?.[0] && update?.[1]) {
      setDateRange(update);
      setShowDatePopup(false);
    }
  };

  const datePopupRef = useRef(null);
  const guestsPopupRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (datePopupRef.current && !datePopupRef.current.contains(e.target)) {
        setShowDatePopup(false);
      }

      if (
        guestsPopupRef.current &&
        !guestsPopupRef.current.contains(e.target)
      ) {
        setShowGuests(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // ===== טעינה =====

  const [loading, setLoading] = useState(false);

  const formatToISO = (date) => {
    const offset = date.getTimezoneOffset();
    return new Date(date.getTime() - offset * 60000)
      .toISOString()
      .split("T")[0];
  };

  const handleSubmit = async () => {
    if (!startDate || !endDate) return;

    setLoading(true);
    const guestsCount = guests > 0 ? guests : 1;
    const params = {
      checkIn: formatToISO(startDate),
      checkOut: formatToISO(endDate),
      guests: guestsCount,
    };
    await onSearch(params);

    // עובר לדף הנכסים רק אם לא שם
    const villasPage = "/"; // שנה לכתובת האמיתית

    if (!window.location.pathname.includes(villasPage)) {
      window.location.href =
        villasPage + "?" + new URLSearchParams(params).toString();
      return;
    }
    setLoading(false);
  };
  return (
    <div id="guesty-react-app">
      <div className="booking-bar">
        {/* === תאריכים === */}
        <div
          className="field"
          onClick={() => {
            setTempRange(dateRange);
            setShowDatePopup(true);
          }}
        >
          <label>תאריך הגעה / יציאה</label>
          <div className="field-display">
            {startDate && endDate
              ? `${startDate.toLocaleDateString(
                  "he-IL"
                )} - ${endDate.toLocaleDateString("he-IL")}`
              : "בחר תאריכים"}

            <div className="nights-box">
              {nights > 0 ? `${nights} לילות` : "בחר טווח תאריכים"}
            </div>
          </div>

          {showDatePopup && (
            <div
              className="popup"
              ref={datePopupRef}
              onClick={(e) => e.stopPropagation()}
            >
              <DatePicker
                inline
                selectsRange
                startDate={tempRange[0]}
                endDate={tempRange[1]}
                onChange={handleDateChange}
                minDate={new Date()}
                dateFormat="dd/MM/yyyy"
                locale="he"
              />
            </div>
          )}
        </div>

        {/* === אורחים === */}
        <div className="field" onClick={() => setShowGuests((s) => !s)}>
          <label>אורחים</label>
          <div className="field-display">
            {guests > 0 ? `${guests} אורח${guests > 1 ? "ים" : ""}` : "אורחים"}
          </div>

          {showGuests && (
            <div
              className="popup guests-popup"
              ref={guestsPopupRef}
              onClick={(e) => e.stopPropagation()}
            >
              <div className="guest-room">
                <span>אורחים</span>
                <div className="counter">
                  <button
                    type="button"
                    onClick={() => setGuests((g) => Math.max(0, g - 1))}
                    aria-label="הפחת אורחים"
                  >
                    −
                  </button>
                  <span>{guests}</span>
                  <button
                    type="button"
                    onClick={() => setGuests((g) => g + 1)}
                    aria-label="הוסף אורחים"
                  >
                    +
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* === כפתור חיפוש === */}
        <button
          className="search-btn"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? (
            <div className="loader-dots">
              <span>.</span>
              <span>.</span>
              <span>.</span>
            </div>
          ) : (
            "חיפוש נכסים"
          )}
        </button>
      </div>
    </div>
  );
}
